var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.87358 1.58401L9.88428 3.75586L6.99925 6.00132",
    stroke: "#6D7D8B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91613 3.61895C7.34021 3.40972 5.74225 3.78528 4.42452 4.6746C3.10679 5.56391 2.16065 6.90531 1.76509 8.44506C1.36952 9.98481 1.55195 11.6161 2.27787 13.0305C3.00379 14.4448 4.22286 15.5441 5.70449 16.1203C7.18612 16.6966 8.82757 16.7099 10.3183 16.1577C11.8091 15.6055 13.0458 14.5262 13.7946 13.1238C14.5433 11.7214 14.7522 10.0933 14.3816 8.54729C14.011 7.00134 13.0868 5.64478 11.7836 4.73423",
    stroke: "#6D7D8B",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListReset);
export default __webpack_public_path__ + "static/media/ListReset.1b5ae488.svg";
export { ForwardRef as ReactComponent };